import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import Table from '@tiptap/extension-table'
import TextStyle from '@tiptap/extension-text-style';
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import { Color } from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import TableRow from '@tiptap/extension-table-row'
import LetterSpacing from "tiptap-extension-letter-spacing";
import LineHeight from "tiptap-extension-line-height";
import { FontFamily } from '@tiptap/extension-font-family'

import { TableView } from './customTableView'
import { Extension } from '@tiptap/core';

const customTable = Table.configure({
  View: TableView,
  resizable: true,
  HTMLAttributes: {
    class: 'table table-bordered',
  },
})

const customTableHeader = TableHeader.extend({
  content: 'text*'
})

const customTableCell = TableCell.extend({
  content: 'text*'
})

const customTextStyle = TextStyle.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      fontSize: {
        default: null,
        parseHTML: (element) => element.style.fontSize.replace('px', ''),
        renderHTML: (attributes) => {
          if (!attributes['fontSize']) {
            return {};
          }
          return {
            style: `font-size: ${attributes['fontSize']}px`,
          };
        }
      }
    }
  },
  addCommands() {
    return {
      ...this.parent?.(),
      setFontSize: (fontSize) => ({ commands }) => commands.setMark(this.name, { fontSize }),
      unsetFontSize: () => ({ chain }) => chain().setMark(this.name, { fontSize: null }).removeEmptyTextStyle().run()
    }
  }
})

const Uppercase = Extension.create({
  name: 'uppercase',

  addCommands() {
    return {
      setUppercase:
        () => ({ state, tr }) => {
          const { from, to } = state.selection
          const text = state.doc.textBetween(from, to)
          tr.insertText(text.toUpperCase(), from, to)
          return true
        },
    }
  },
})

const Lowercase = Extension.create({
  name: 'lowercase',

  addCommands() {
    return {
      setLowercase:
        () => ({ state, tr }) => {
          const { from, to } = state.selection
          const text = state.doc.textBetween(from, to)
          tr.insertText(text.toLowerCase(), from, to)
          return true
        },
    }
  },
})

const Capitalize = Extension.create({
  name: 'capitalize',

  addCommands() {
    return {
      setCapitalize:
        () => ({ state, tr }) => {
          const { from, to } = state.selection
          const text = state.doc.textBetween(from, to)
          const capitalized = text.replace(/\b\w/g, char => char.toUpperCase())
          tr.insertText(capitalized, from, to)
          return true
        },
    }
  },
})

export default [
  StarterKit,
  Underline,
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  customTextStyle,
  Color,
  Highlight.configure({ multicolor: true }),
  Subscript,
  Superscript,
  Link.configure({
    openOnClick: false,
  }),
  Image.configure({
    allowBase64: true,
  }),
  customTable,
  TableRow,
  customTableHeader.configure({
    HTMLAttributes: {
      scope: 'col',
    },
  }),
  customTableCell,
  LetterSpacing,
  LineHeight,
  FontFamily,
  Uppercase,
  Lowercase,
  Capitalize,
]
